import React from 'react';
import { Alert, Container, LinearProgress, Stack } from '@mui/material';

import { useAuth } from '../auth/AuthContext';
import { hasAccountingAccess } from '../../subscription';
import UpgradeNotice from '../shared/UpgradeNotice';
import FinancialReportDetailsTable from './financial-report/FinancialReportDetailsTable';
import FinancialReportHeaderCard from './financial-report/FinancialReportHeaderCard';
import FinancialReportSummaryCards from './financial-report/FinancialReportSummaryCards';
import FinancialReportTrendCard from './financial-report/FinancialReportTrendCard';
import useFinancialReportData from './financial-report/useFinancialReportData';

export default function FinancialReport() {
    const { user } = useAuth();
    const hasAccounting = hasAccountingAccess(user?.paymentPlan);

    const {
        mode,
        filters,
        data,
        loading,
        error,
        expandedPeriods,
        expandedAccounts,
        chartSeries,
        chartWidth,
        availableCostCenters,
        formattedTotals,
        handleModeChange,
        handleFromChange,
        handleToChange,
        handleCostCentersChange,
        handleApplyFilters,
        handleExport,
        togglePeriod,
        toggleAccount,
    } = useFinancialReportData({ hasAccounting });

    if (!hasAccounting) {
        return (
            <Container maxWidth="lg" sx={{ py: 6 }}>
                <UpgradeNotice featureName="Auswertungen" />
            </Container>
        );
    }

    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Stack spacing={3}>
                <FinancialReportHeaderCard
                    mode={mode}
                    filters={filters}
                    availableCostCenters={availableCostCenters}
                    loading={loading}
                    hasData={Boolean(data?.periods?.length)}
                    onModeChange={handleModeChange}
                    onFromChange={handleFromChange}
                    onToChange={handleToChange}
                    onCostCentersChange={handleCostCentersChange}
                    onApplyFilters={handleApplyFilters}
                    onExport={handleExport}
                />

                {loading && <LinearProgress />}
                {error && <Alert severity="error">{error}</Alert>}

                <FinancialReportSummaryCards totals={formattedTotals} />
                <FinancialReportTrendCard chartSeries={chartSeries} chartWidth={chartWidth} />
                <FinancialReportDetailsTable
                    data={data}
                    loading={loading}
                    expandedPeriods={expandedPeriods}
                    expandedAccounts={expandedAccounts}
                    onTogglePeriod={togglePeriod}
                    onToggleAccount={toggleAccount}
                />
            </Stack>
        </Container>
    );
}
